import { PageType } from 'app-types';

export const PAGE_IN_VIEW = 'PAGE_IN_VIEW' as const;

export const pageSelected = (page: string | null = null, pageType: PageType | null = null) => {
  return {
    type: PAGE_IN_VIEW,
    payload: {
      page,
      type: pageType,
    },
  };
};
